import { prefixObjectValues } from '../../utils';

const table = {
  id: 'id',
  title: 'title',
  activeFlag: 'active-flag',
  filledFlag: 'filled-flag',
  workLocation: 'work-location',
  createBtn: 'create-btn',
  layout: 'layout',
  row: 'row',
  editBtn: 'edit-btn',
  deleteBtn: 'delete-btn',
  deactivateBtn: 'deactivate-btn',
};
export default prefixObjectValues(table, 'table');
